import { Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualificationDetailValuesQuickInfo extends Layout {
    labelTooltip: Label;
}
